var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #030e1f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.61,0H1.39C.62,0,0,.62,0,1.39v16.23c0,.77.62,1.39,1.39,1.39h16.23c.77,0,1.39-.62,1.39-1.39V1.39c0-.77-.62-1.39-1.39-1.39ZM5.54,16.23h-2.77V7.12h2.77v9.1ZM5.78,4.22s0,0,0,0c-.02.87-.75,1.56-1.62,1.54h-.02c-.9-.01-1.61-.75-1.6-1.64.01-.9.75-1.61,1.64-1.6.9.01,1.61.75,1.6,1.64v.06ZM16.23,16.23h-2.77v-4.79c0-1.46-.81-2.07-1.6-2.07-.97,0-1.96.65-1.96,2.11v4.75h-2.77V7.12h2.61v1.29h.04c.26-.56,1.44-1.48,3.03-1.48s3.42,1.08,3.42,3.85v5.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcn);
export default __webpack_public_path__ + "static/media/linkedin-icn.cbcf3b7bc9df565579feb6bf6f536db0.svg";
export { ForwardRef as ReactComponent };